<!-- 数据实体管理-列详情 -->
<template>
<div>
  <Table
    ref="table"
    :loadObj='{}'
    :option="{}"
    :colObj='{
      opId:"103",
      name:"列详情",
      parentId:"TABLE_ID",
      parentName:"数据实体管理",
      parentPath:"/system/dataBase",
      dataClass:2,
      col:[],
      addBtnClick,
    }'
  >
  </Table>
</div>
</template>

<script>
import Table from '@/components/table/dataTablecSon';
import {processDeal} from '@/api/home/home';
export default {
  components: {
    Table
  },
  data() {
    return {
      firstEnter:true,
    };
  },
  computed: {
  },
  methods: {
    // 顶部刷新数据实体
    refreshBtnClick(){
      processDeal({obj:JSON.stringify({id:8,tablename:this.$route.query.tableName,appendflag:1})}).then(res=>{
        this.$refs.table.$refs.child.onLoad();
        this.$message.success("刷新数据实体成功!");
      },err=>{})
    },
  },
  created(){
  },
  activated(){
    if(this.firstEnter){
      this.firstEnter=false;
    }else{
      this.$refs.table.$refs.child.onLoad();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
